// import from auth apis
import { muesApiSlice } from "../authentication/authentication";

export const otherApi=muesApiSlice.injectEndpoints({
    endpoints: builder =>({
        // list of query
        getPincode : builder.query({
            query : (queryParam)=>({
                url: 'pincode',
                method: 'GET',
                params: queryParam,
            })
        }),
        getIcon : builder.query({
            query : ()=>({
                url: 'icon',
                method: 'GET',
            })
        }),
        getStandardTopic : builder.query({
            query : (queryParam)=>({
                url: 'standard-topic',
                method: 'GET',
                params: queryParam,
            })
        }),
        getActivityCategory : builder.query({
            query : (queryParam)=>({
                url: 'activity-category',
                method: 'GET',
                params: queryParam,
            })
        }),
        getSubStandardTopic : builder.query({
            query : (queryParam)=>({
                url: 'sub-standard-topic',
                method: 'GET',
                params: queryParam,
            })
        }),
        getSkillList : builder.query({
            query : (queryParam)=>({
                url: `skill`,
                method: 'GET',
                params: queryParam,
            })
        }),
        getAreaOfDevelopmentSkill : builder.query({
            query : (queryParam)=>({
                url: `skill/${queryParam}`,
                method: 'GET',
            })
        }),
        getStudentAttendance : builder.query({
            query : (queryParam)=>({
                url: 'student-attendance-status',
                method: 'GET',
                params: queryParam,
            })
        }),
        getStaffAttendance : builder.query({
            query : (queryParam)=>({
                url: 'staff-attendance-status',
                method: 'GET',
                params: queryParam,
            })
        }),
        getReviewList : builder.query({
            query : (queryParam)=>({
                url: 'review',
                method: 'GET',
                params: queryParam,
            })
        }),
        getAreaOfDevelopement : builder.query({
            query : ()=>({
                url: 'area-of-development',
                method: 'GET',
            }),
        }),
        getStageList : builder.query({
            query : ()=>({
                url: 'stage',
                method: 'GET',
            }),
        }),

        // schedule call
        scheduleCall: builder.mutation({
            query: (requestBody) => ({
              url: "other/contacts",
              method: "POST",
              body: requestBody,
            }),
        }),
        newsLetter: builder.mutation({
            query: (requestBody) => ({
              url: "other/news-letter/",
              method: "POST",
              body: requestBody,
            }),
        }),
    })
})

export const { useGetPincodeQuery, useGetIconQuery,
    useLazyGetStandardTopicQuery, useGetStandardTopicQuery,
    useLazyGetSkillListQuery, useGetSkillListQuery, useGetStudentAttendanceQuery,
    useGetReviewListQuery, useGetAreaOfDevelopementQuery, useGetStageListQuery,
    useGetAreaOfDevelopmentSkillQuery, useScheduleCallMutation, useNewsLetterMutation,
    useGetStaffAttendanceQuery, useGetSubStandardTopicQuery, useGetActivityCategoryQuery
}=otherApi